<template>
  <div class="book-item">
    <div class="book-imgWrap" @click="navigate()">
      <div class="book-img">
        <img v-lazy="imgObj || {}" />
      </div>

      <div v-if="icon.vip" class="vipOnly">
        <img src="https://img.yzcdn.cn/upload_files/2019/12/06/FiCIxw3z4yGn5zC7GHtsos4GZVGW.png" />
      </div>
      <div v-if="isAnswer" class="isAnswer"></div>
      <div v-if="newest" class="newest1">最新</div>
    </div>

    <div v-if="describe" class="book-name" :class="order ? '' : 'order'">{{ bookName }}</div>
    <div v-if="describe && order" class="book-edition">{{ bookEdition }}</div>
    <suMask :show.sync="vipPopup" :opacity="0.6" click>
      <div class="su-subModel">
        <div class="su-subTop">
          <img src="/cms/static/images/qxk/apply.png" />
          <span class="su-subModel-title"> 本书{{ onlineDate }}上线 <br />现仅限会员抢先看 </span>
          <!-- <span class="su-subModel-message">您已成功订阅，VIP拥有抢先查看特权
                        可提前7天查看，是否开启特权
          </span>-->
        </div>
        <div class="su-subsBottom">
          <div class="su-subsBottomItem close" @click.stop="() => (vipPopup = !vipPopup)">
            <span>等几天</span>
          </div>
          <div class="su-subsBottomItem fast" @click.stop="payVip">
            <span>开通会员现在看</span>
          </div>
        </div>
      </div>
    </suMask>
  </div>
</template>
<script>
import suMask from '@/components/suMask'
import { getBookHref } from '@/static/js/business'

export default {
  components: {
    suMask
  },
  props: {
    bookImg: {
      type: String,
      default: 'https://img.yzcdn.cn/upload_files/2019/12/18/FiHMp7Sh-y_HisCBRFnxeHg-eQWD.png'
    },
    bookName: {
      type: String,
      default: '同步练习册语文数学'
    },
    bookEdition: {
      type: String,
      default: '人教版'
    },
    describe: {
      type: Boolean,
      default: true
    },
    bookStatus: {},
    linkTo: {
      type: Boolean,
      default: true
    },
    hash: {
      type: Boolean,
      default: true
    },
    route: {
      type: Boolean,
      default: false
    },
    effectiveDate: {
      type: [Number, String],
      default: 0
    },
    order: {
      // 单本售卖订单支付成功推荐书籍 不展示版本
      type: Boolean,
      default: true
    },
    hideNewBrage: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      vipPopup: false,
      onlineDate: ''
    }
  },
  computed: {
    // 兼容新答案页和搜索页面数据
    status() {
      return this.bookStatus.status || this.bookStatus.wbStatus
    },
    bookId() {
      return this.bookStatus.id || this.bookStatus.wbId.split('_')[1]
    },
    imgObj() {
      return {
        src: this.bookImg,
        error: 'https://img.yzcdn.cn/upload_files/2019/12/18/FiHMp7Sh-y_HisCBRFnxeHg-eQWD.png',
        loading: 'https://img.yzcdn.cn/upload_files/2019/12/18/FiHMp7Sh-y_HisCBRFnxeHg-eQWD.png'
      }
    },
    // 图标展示逻辑
    icon() {
      const bookStatus = this.bookStatus
      // 会员专享
      const vipUseOnly = Number(bookStatus.vVipUseOnly) || bookStatus.vipUseOnly
      // 发布年份
      const publishYear =
        bookStatus.wbPublishYear || bookStatus.vPublishYear || bookStatus.wbpublishyear
      if (vipUseOnly) {
        return {
          vip: true
        }
      } else {
        return {
          year: publishYear || false
        }
      }
    },
    isAnswer() {
      const p = ['keben_answer', 'jiaofu_answer']
      return p.includes(this.bookStatus.category)
    },
    // 新上架14天以内，显示最新上架
    newest() {
      if (this.hideNewBrage) return false
      const timing = 1000 * 3600 * 24 * 14
      const timeDifference = new Date() - new Date(this.effectiveDate)
      if (timeDifference > 0 && timeDifference < timing) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    cardClick() {
      this.$emit('card-click')
    },
    getPublishYearImg(year) {
      return `/cms/static/images/new/${year}.png`
    },
    payVip() {
      window.location.href = '/cms/weixin/user/vipMain?channel=svip_dahd_hyzx_gn'
    },
    getDate() {},
    // 跳转控制
    navigate() {
      if (!this.linkTo) {
        this.cardClick()
        return
      }
      const id = this.bookId
      const { vipUseOnly, vVipUseOnly, onlineDate, category } = this.bookStatus
      const { vipLevel } = this.$store.userInfo
      // 判断书籍是不是用户专享
      const isVipOnly = vipUseOnly || Number(vVipUseOnly)
      // 判断用户是不是vip
      const isNoVip = !vipLevel || vipLevel === 'nv'
      if (isNoVip && isVipOnly) {
        this.onlineDate = onlineDate
        this.vipPopup = true
        return
      }
      if (this.route) {
        this.$emit('toBook', id)
      } else if (id) {
        if (this.hash) {
          const url = getBookHref({
            id,
            category,
            origin: true
          })
          window.location.hash = new URL(url).hash
        } else {
          const url = getBookHref({
            id,
            category
          })
          window.location.href = url
        }
      }
    }
  }
}
</script>
<style lang="scss">
.book-item {
  text-align: left;

  .book-imgWrap {
    position: relative;

    img {
      display: block;
      width: 100%;
    }

    .book-img {
      overflow: hidden;
      border-radius: 0.08rem;

      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }

    .willUp {
      position: absolute;
      top: 0%;
      left: 0;
      width: 100%;
      height: 100%;
      // background: rgba(0, 0, 0, 0.4);
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        display: block;
        width: 1.76rem;
      }
    }
  }
}

.newest1 {
  position: absolute;
  top: 0;
  left: 0;
  margin: auto;
  width: 28px;
  height: 15px;
  font-size: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(293.48deg, #f55a53 10.33%, #ff7b6b 108.87%);
  border-radius: 0.08rem 0;
  color: #ffffff;
  // background: url(https://img01.yzcdn.cn/upload_files/2021/11/12/Fq_TPVtUwGBGFdSQURI7cF7emap-.png)
  // no-repeat;
  background-size: contain;
  //z-index: 1;
}

.isAnswer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 21px;
  display: flex;
  justify-content: center;
  background: linear-gradient(104.23deg, #fc7365 17.52%, #f55b53 69.38%);
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}

.isAnswer:after {
  line-height: 21px;
  content: '仅参考答案';
  color: #ffffff;
  font-size: 12px;
  font-weight: 300;
}

.book-name {
  margin-top: 0.29rem;
  font-size: 0.37rem;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  width: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;

  &.order {
    font-size: 12px;
    color: #333333;
  }
}

.book-edition {
  // margin-top: 0.21rem;
  margin-top: 4px;
  font-size: 0.32rem;
  font-weight: 400;
  // color: rgba(74, 74, 74, 1);
  color: #b2b2b2;
}

.book-year {
  position: absolute;
  top: 0%;
  left: 0;
  width: 100%;
  height: 100%;
}

.vipOnly {
  position: absolute;
  z-index: 2;
  top: -1px;
  left: -4px;
  width: 52px;
}

.su-subModel {
  width: 80%;
  border-radius: 4px;
  margin: 0 auto;
  z-index: 99999;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #ffffff;
  text-align: center;

  .su-subTop {
    padding: 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  img {
    width: 50%;
  }

  .su-subModel-title {
    margin: 16px 0 21px 0;
    font-size: 18px;
    font-weight: 500;
  }

  .su-subModel-message {
    font-size: 15px;
    line-height: 21px;
    color: #999999;
  }

  .su-subsBottom {
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    width: 100%;

    .su-subsBottomItem {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      width: 50%;
      text-align: center;
      font-size: 18px;
      height: 50px;
      border-top: solid 1px #f0eded;
    }

    .close {
      border-right: solid 1px #f0eded;
      color: rgba(128, 128, 128, 1);
    }

    .fast {
      color: rgba(233, 74, 78, 1);
    }
  }
}
</style>
